/**
 * Super Admin UI origin used by Support Mode ("End impersonation" returns the
 * SA operator to the Super Admin app of the SAME stage).
 *
 * Canonical configuration lives in the stage env system (.env-cmdrc):
 *   staging    → REACT_APP_SA_UI_ORIGIN=https://staging.superadmin.krosskast.com
 *   production → REACT_APP_SA_UI_ORIGIN=https://superadmin.krosskast.com
 *
 * Fail closed: there is deliberately NO cross-stage default. A production
 * bundle must never carry a staging origin "just in case" (2026-09-17 audit:
 * the previous `|| "https://staging.superadmin.krosskast.com"` fallback
 * shipped to production and would have returned SA operators to staging).
 */

export const SA_UI_ORIGIN_ENV_KEY = "REACT_APP_SA_UI_ORIGIN";

export class SaUiOriginNotConfiguredError extends Error {
  constructor() {
    super(
      `${SA_UI_ORIGIN_ENV_KEY} is not configured for this stage. ` +
        "Set it in .env-cmdrc (staging/production) — Support Mode cannot " +
        "guess which Super Admin environment to return to.",
    );
    this.name = "SaUiOriginNotConfiguredError";
  }
}

/**
 * @param {Record<string, string|undefined>} [env] defaults to process.env
 * @returns {string} origin without trailing slash
 * @throws {SaUiOriginNotConfiguredError} when unset/blank
 */
export function resolveSaUiOrigin(env = process.env) {
  const raw = String(env?.[SA_UI_ORIGIN_ENV_KEY] || "")
    .trim()
    .replace(/\/+$/, "");
  if (!raw) throw new SaUiOriginNotConfiguredError();
  return raw;
}

/** `${saOrigin}/accounts` — the SA landing used after ending Support Mode. */
export function buildSupportModeReturnUrl(env = process.env) {
  return `${resolveSaUiOrigin(env)}/accounts`;
}
